<!-- Loader -->
<div class="loader-overlay">
  <div class="loader-container">
    <div class="bg-image"></div>
    <div class="spinner"></div>
  </div>
</div>
